import mod from "-!../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/js/conf/home/App.vue?vue&type=script&lang=js&
// module id = 204
// module chunks = 30